import React, { Component } from "react";
import apiProxy from "../../api/apiProxy.js";
import AlertDetailsPage from "./AlertDetailsPage";
import LoadingWrapper from "../LoadingWrapper";
import PageTitle from "../PageTitle";
import { Event } from "../Tracking";

class AlertDetailsPageWrapper extends Component {
  state = {
    alert: {},
    energyData: {},
    energyChartIsLoading: false,
    workflow: {},
    isLoading: true
  };

  componentDidMount() {
    this.loadAlert();
  }

  loadAlert = () => {
    this.setState({ isLoading: true });

    apiProxy.alert
      .getAlert(this.props.match.params.alertId)
      .then(response => {
        const alert = response;
        this.setState({ alert: alert, isLoading: false });
      })
      .catch(response => {
        this.handleError(response);
      });
  };

  loadEnergyData = (chartDataResolution, from, to, onComplete) => {
    this.setState({ energyChartIsLoading: true });

    apiProxy.sensor
      .getData(this.state.alert.sensor.sensorId, chartDataResolution, from, to)
      .then(response => {
        this.setState(
          {
            energyData: response,
            energyChartIsLoading: false
          },
          onComplete
        );
      })
      .catch(response => {
        this.handleError(response);
      });
  };

  changeIncludeDataInBaseline = (includeDataInBaseline, onComplete) => {
    const workflow = this.state.workflow;
    workflow.isLoading = true;
    this.setState({ workflow: workflow });

    apiProxy.alert
      .updateAlertIncludeDataInBaseline(
        this.state.alert.alertId,
        includeDataInBaseline
      )
      .then(() => {
        workflow.isLoading = false;
        this.setState({ workflow: workflow }, onComplete);
      })
      .catch(response => {
        this.handleError(response);
      });
  };

  changeStatus = (status, onComplete) => {
    const workflow = this.state.workflow;
    workflow.isLoading = true;
    this.setState({ workflow: workflow });

    if (status === "Closed") {
      Event(
        "Alerting Event",
        status,
        this.state.alert.alertReference,
        this.state.alert.value
      );
    } else {
      Event("Alerting Event", status, this.state.alert.alertReference);
    }

    apiProxy.alert
      .updateAlertStatus(this.state.alert.alertId, status)
      .then(() => {
        workflow.isLoading = false;
        this.setState({ workflow: workflow }, onComplete);
      })
      .catch(response => {
        this.handleError(response);
      });
  };

  handleError = response => {
    this.props.onError(response);
  };

  render() {
    return (
      <PageTitle title={this.state.alert.alertReference}>
        <LoadingWrapper isLoading={this.state.isLoading}>
          <AlertDetailsPage
            alert={this.state.alert}
            workflow={this.state.workflow}
            changeStatus={this.changeStatus}
            changeIncludeDataInBaseline={this.changeIncludeDataInBaseline}
            redirectTo={this.props.location?.state?.redirectTo}
            loadAlert={this.loadAlert}
            loadEnergyData={this.loadEnergyData}
            energyData={this.state.energyData}
            energyChartIsLoading={this.state.energyChartIsLoading}
          />
        </LoadingWrapper>
      </PageTitle>
    );
  }
}

export default AlertDetailsPageWrapper;
